var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 3.875C8.05021 3.875 6.875 5.05021 6.875 6.5C6.875 7.94979 8.05021 9.125 9.5 9.125C10.9498 9.125 12.125 7.94979 12.125 6.5C12.125 5.05021 10.9498 3.875 9.5 3.875ZM8.625 6.5C8.625 6.01674 9.01674 5.625 9.5 5.625C9.98326 5.625 10.375 6.01674 10.375 6.5C10.375 6.98326 9.98326 7.375 9.5 7.375C9.01674 7.375 8.625 6.98326 8.625 6.5Z",
    fill: "#261F53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1012 5.87061C16.0992 2.25788 12.8357 0.375 9.5 0.375C6.1643 0.375 2.90072 2.25788 0.898777 5.87061C0.703074 6.22385 0.700659 6.65934 0.890254 7.01415C2.86035 10.7011 6.14245 12.625 9.5 12.625C12.8576 12.625 16.1397 10.7011 18.1097 7.01415C18.2994 6.65934 18.2969 6.22385 18.1012 5.87061ZM9.5 10.875C6.92835 10.875 4.28546 9.45085 2.58026 6.45511C4.31004 3.52162 6.93904 2.125 9.5 2.125C12.061 2.125 14.69 3.52162 16.4198 6.45511C14.7146 9.45085 12.0716 10.875 9.5 10.875Z",
    fill: "#261F53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.1dc7d2a5098144fef69061e681c7f7ec.svg";
export { ForwardRef as ReactComponent };